import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _HeaderMenu;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { View } from '@instructure/ui-view';
import { Menu } from '@instructure/ui-menu';
import { IconButton } from '@instructure/ui-buttons';
import { TopNavBar } from '@instructure/ui-top-nav-bar';
import { Drilldown } from '@instructure/ui-drilldown';
import { IconMoreSolid, IconImportLine } from '@instructure/ui-icons';
import { jsx } from '@instructure/emotion';
import QTIImportModal from '../../../building/components/QTIImportModal';
import { PARENT_TYPE_BANK, withStyleOverrides } from '@instructure/quiz-common';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import t from '@instructure/quiz-i18n/format-message';
export var HeaderMenu = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_HeaderMenu = /*#__PURE__*/function (_Component) {
  function HeaderMenu() {
    _classCallCheck(this, HeaderMenu);
    return _callSuper(this, HeaderMenu, arguments);
  }
  _inherits(HeaderMenu, _Component);
  return _createClass(HeaderMenu, [{
    key: "renderMenu",
    value: function renderMenu() {
      if (this.props.iceTopNavBarEnabled) {
        return jsx(TopNavBar.Item, {
          id: this.props.id,
          variant: "icon",
          renderIcon: this.props.renderIcon,
          showSubmenuChevron: false,
          renderSubmenu: jsx(Drilldown, {
            rootPageId: "root"
          }, jsx(Drilldown.Page, {
            id: "root"
          }, jsx(Drilldown.Option, {
            id: "import",
            key: "import",
            disabled: !this.props.bank.canImport(),
            onOptionClick: this.props.openImportModal
          }, jsx(IconImportLine, {
            "data-automation": "sdk-headermenu-import-content"
          }), jsx(View, {
            as: "span",
            margin: "0 0 0 x-small"
          }, t('Import Content')))))
        }, t('More Item Banking Actions'));
      }
      return jsx(Menu, {
        trigger: jsx(IconButton, {
          renderIcon: IconMoreSolid,
          withBackground: false,
          withBorder: false,
          screenReaderLabel: t('More Item Banking Actions')
        })
      }, jsx(Menu.Item, {
        key: "import",
        disabled: !this.props.bank.canImport(),
        onSelect: this.props.openImportModal
      }, jsx(IconImportLine, {
        css: this.props.styles.menuIcon,
        "data-automation": "sdk-headermenu-import-content"
      }), t('Import Content')));
    }
  }, {
    key: "render",
    value: function render() {
      var bank = this.props.bank;
      return jsx("div", {
        css: this.props.styles.container
      }, this.renderMenu(), jsx(QTIImportModal, {
        parentId: bank.id,
        parentType: PARENT_TYPE_BANK,
        qtiImport: bank.getLatestImport(),
        "data-automation": "sdk-qti-import-modal"
      }));
    }
  }]);
}(Component), _defineProperty(_HeaderMenu, "displayName", 'HeaderMenu'), _defineProperty(_HeaderMenu, "componentId", "Quizzes".concat(_HeaderMenu.displayName)), _defineProperty(_HeaderMenu, "propTypes", {
  openImportModal: PropTypes.func.isRequired,
  bank: ImmutablePropTypes.record.isRequired,
  iceTopNavBarEnabled: PropTypes.bool,
  id: PropTypes.string,
  renderIcon: PropTypes.element,
  styles: PropTypes.object
}), _defineProperty(_HeaderMenu, "defaultProps", {
  iceTopNavBarEnabled: false,
  id: 'BankMenu',
  renderIcon: jsx(IconMoreSolid, null)
}), _HeaderMenu)) || _class);
export default HeaderMenu;